import {
  DataArrayOutlined,
  ExploreOutlined,
  HubOutlined,
  MonetizationOnOutlined,
  SettingsInputCompositeOutlined,
  UploadFileOutlined,
} from '@mui/icons-material';
import { Divider, List, ListItemIcon, ListItemText } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';
import { NavCollapse, NavDrawerProps, NavSubListItem } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';
import { Link, useMatch } from 'react-router-dom';

import { NavId, FeatureFlag } from '~/common/types';
import { CustomDataNavList } from '~/components/CustomDataNavList/CustomDataNavList';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { NavSubListItemLink } from '~/components/NavSubListItemLink/NavSubListItemLink';
import { RouteId } from '~/routes/RouteId';

export const DataFoundationDrawer = (props: NavDrawerProps) => {
  const savingsRoute = RouteId.savings;

  return (
    <NavDrawerSimple navId={NavId.dataFoundation} {...props}>
      <NavCollapse in={true} label={<Trans i18nKey="Nav.dataFoundationOntology" />} sx={{ marginBottom: 4 }}>
        <List>
          <NavSubListItemLink
            id={NavId.dataFoundationIntegrationHub}
            Icon={SettingsInputCompositeOutlined}
            needs={{ feature: FeatureFlag.DEMO_DATA_FOUNDATION }}
          />
          <NavSubListItemLink
            id={NavId.dataFoundationEnrichmentHub}
            Icon={UploadFileOutlined}
            needs={{ feature: FeatureFlag.DEMO_DATA_FOUNDATION }}
          />
          <NavSubListItemLink
            id={NavId.dataFoundationExplorer}
            Icon={ExploreOutlined}
            needs={{ feature: FeatureFlag.DEMO_DATA_FOUNDATION }}
          />
        </List>
      </NavCollapse>
      <Restricted needs={{ permission: Permission.CmdiSavingEdit }}>
        <List disablePadding sx={{ marginBottom: 4 }}>
          {/* end: false keeps the item selected on the saving deep link (/savings/:id) */}
          <NavSubListItem component={Link} to={savingsRoute} selected={!!useMatch({ path: savingsRoute, end: false })}>
            <ListItemIcon>
              <MonetizationOnOutlined />
            </ListItemIcon>
            <ListItemText primary={<Trans i18nKey="Nav.dataFoundationSavings" />} />
          </NavSubListItem>
        </List>
      </Restricted>
      <Restricted
        needs={{
          permission: {
            any: [
              Permission.CmdiAcountingAreaEdit,
              Permission.CmdiCapabilityEdit,
              Permission.CmdiCommodityEdit,
              Permission.CmdiCommodityGroupEdit,
              Permission.CmdiContactEdit,
              Permission.CmdiOrganisationEdit,
              Permission.CmdiSupplierEdit,
              Permission.CmdiUnitEdit,
            ],
          },
        }}
      >
        <NavCollapse
          in={true}
          icon={<DataArrayOutlined />}
          label={<Trans i18nKey="Nav.dataFoundationCustom" />}
          sx={{ marginBottom: 4 }}
        >
          <CustomDataNavList />
        </NavCollapse>
      </Restricted>
      <Divider />
      <Restricted needs={{ feature: FeatureFlag.DEMO_DATA_FOUNDATION }}>
        <List disablePadding sx={{ marginBottom: 4 }}>
          <NavSubListItem>
            <ListItemIcon>
              <HubOutlined />
            </ListItemIcon>
            <ListItemText primary={<Trans i18nKey="Nav.knowledgeGraph" />} />
          </NavSubListItem>
        </List>
      </Restricted>
    </NavDrawerSimple>
  );
};
